<template>
<div class="page page_dingzhi page_order page_ziti">
    <van-tabs v-model="active" swipe-threshold="4" @click="onTabsClick">
        <van-tab title="全部" :name="0"></van-tab>
        <van-tab title="待支付" :name="1"></van-tab>
        <van-tab title="待提货" :name="2"></van-tab>
        <van-tab title="待评价" :name="3"></van-tab>
    </van-tabs>
    <!--  -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list">
                <div class="item" v-for="(order,index) in orderList" :key="index">
                    <div class="item_t">
                        <div class="item_t_l">
                            <img :src="order.tradesman_thumb ? ($publicData.withHttpStart(order.tradesman_thumb) ? order.tradesman_thumb : imageUrl+order.tradesman_thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
                            <div class="user_name slh_s" style="margin-left:0.2rem">{{order.tradesman_name}}</div>
                        </div>
                        <div class="item_t_r">{{ order.statusTitle }}</div>
                    </div>
                    <div class="item_nr" v-for=" (goods,index) in order.order_good" :key="index" @click="goOrderDetail(order)">
                        <div :class="goods.is_blockchain ? 'item_nr_l blockchain' : 'item_nr_l'">
                            <img :src="goods.thumb ? imageUrl+goods.thumb: $publicData.intangibleDefault" alt="" class="tu">
                        </div>
                        <div class="item_nr_r">
                            <div class="item_nr_r_t">
                                <div class="title slh">{{ goods.title }}</div>
                                <div class="info">
                                    <span class="price"><span class="tag_cash">¥</span>{{ goods.price }}</span>
                                    <span class="nums">x{{ goods.num }}</span>
                                </div>
                            </div>
                            <div class="sku">{{ goods.spec_name }}</div>
                        </div>
                    </div>
                    <div class="item_b ziti">
                        <div class="order" v-if="order.discount">折扣:{{order.dazhe}}</div>
                        <div class="order">订单编号:{{order.order_num}}</div>
                        <div class="order">订单产生时间:{{order.created_at}}</div>
                        <div class="actions">
                            <div class="action" v-if="order.order_status!=0 && order.pay_status==0" @click="toPay(order)">付款</div>
                            <!-- <div class="action">评价</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
            active: 0, // 0全部1待付款2待提货3待评论
            page: 1,
            size: 10,
            orderList: [],
            finished: false,
            loading: false,
            refreshing: false,
            goNext: false
        };
    },
    mounted: function () {

        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '我的提货',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                }
            })
            // 注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.onRefresh()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            // this.onRefresh();
        }

    },
    created: function () {

    },
    activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.onRefresh();
		}
	},
    methods: {
        onTabsClick(name, title) {
            this.active = name
            this.onRefresh()
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var params = {
                token: this.token,
                status: this.active,
                page: this.page,
                size: this.size
            };
            console.log('token', this.token)
            this.$api.shop.ztorderlist(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list
                    for (let i = 0; i < list.length; i++) {
                        var order = list[i];
                        // 订单折扣
                        var discount = order.discount
                        if (discount && discount!=0) {
                            var discount = discount.toString()
                            var zhe = ''
                            if (discount.length == 1) {
                                zhe = discount / 10 + '折'
                            } else if (discount.length > 1) {
                                if (discount[discount.length - 1] == 0) {
                                    zhe = discount / 10 + '折'
                                } else {
                                    zhe = discount + '折'
                                }
                            }
                            order.dazhe = zhe
                        }
                        // 订单状态
                        if (order.order_status == 0) {
                            order.statusTitle = '已取消'
                        } else if (order.receipt_status == 1) {
                            // order.statusTitle = '已收货'
                            order.statusTitle = '交易成功'
                        } else {
                            if (order.ship_status == 1) {
                                // order.statusTitle = '已发货'
                                order.statusTitle = '等待提货'
                            } else {
                                if (order.pay_status == 0) {
                                    // order.statusTitle = '未支付'
                                    order.statusTitle = '等待付款'
                                } else if (order.pay_status == 1) {
                                    // order.statusTitle = '支付中'
                                    order.statusTitle = '等待付款'
                                } else if (order.pay_status == 2) {
                                    // order.statusTitle = '已支付'
                                    order.statusTitle = '等待发货'
                                }
                            }
                        }
                    }
                    if (this.page == 1) {
                        this.orderList = list
                    } else {
                        var old = this.orderList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.orderList = old
                    }
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
        },
        // 订单详情
        goOrderDetail(order) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?orderId=" + order.order_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/order/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/order/detail',
                    query: {
                        orderId: order.order_id,
                        type: 1 // 自提订单
                    }
                })
            }
        },
        // 付款
        toPay(order) {
            // 先查一下实际支付金额
            var shifuPrice = order.total_prices
            var params = {
                token: this.token,
                pay_order_num: order.pay_order_num
            }
            this.$api.shop.paymoney(params).then(res => {
                if (res.code == 200) {
                    var dikou = res.result
                    shifuPrice = (order.total_prices - dikou.chargecard - dikou.user_money - dikou.parkscore_money).toFixed(2)
                    // 带着实际支付金额, 跳到支付页面
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        var p = "?orderId=" + order.pay_order_num + '&price=' + shifuPrice + '&park_point=' + order.user_park_point + '&duihuan_money=' + order.user_duihuan_money + '&pay_status=' + order.pay_status
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/shop/pay' + p
                            }
                        }
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    } else {
                        this.goNext = true
                        this.$router.push({
                            path: '/shop/pay',
                            query: {
                                orderId: order.pay_order_num,
                                price: shifuPrice,
                                park_point: order.user_park_point,
                                duihuan_money: order.user_duihuan_money,
                                isPlatprice: order.is_platprice,
                                pay_status: order.pay_status
                            }
                        })
                    }
                }
            })

        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
